export const getBusinesses = state => state.businesses;

export const getFormattedBusiness = () => business => {
    const tags = [];
    business.tags.forEach(tag => {
        tags.push(tag.id);
    });
    business.tags = tags;

    // const paymentOptions = [];
    // if (business.payment_options) {
    //     business.payment_options.forEach((paymentOption) => {
    //         paymentOptions.push(paymentOption.id);
    //     });
    // }
    // business.payment_options = paymentOptions;

    // const parkingOptions = [];
    // if (business.parking_options) {
    //     business.parking_options.forEach((parkingOption) => {
    //         parkingOptions.push(parkingOption.id);
    //     });
    // }
    // business.parking_options = parkingOptions;

    // const facilityOptions = [];
    // if (business.facility_options) {
    //     business.facility_options.forEach((facilityOption) => {
    //         facilityOptions.push(facilityOption.id);
    //     });
    // }
    // business.facility_options = facilityOptions;

    // const serviceOptions = [];
    // if (business.service_options) {
    //     business.service_options.forEach((serviceOption) => {
    //         serviceOptions.push(serviceOption.id);
    //     });
    // }
    // business.service_options = serviceOptions;

    // const amenityOptions = [];
    // if (business.amenity_options) {
    //     business.amenity_options.forEach((amenityOption) => {
    //         amenityOptions.push(amenityOption.id);
    //     });
    // }
    // business.amenity_options = amenityOptions;

    delete business.profile_picture;
    return business;
};
